import { render, staticRenderFns } from "./MaterialGroups.vue?vue&type=template&id=83dde1bc&scoped=true&"
import script from "./MaterialGroups.vue?vue&type=script&lang=ts&"
export * from "./MaterialGroups.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialGroups.vue?vue&type=style&index=0&id=83dde1bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dde1bc",
  null
  
)

export default component.exports